var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('nav', {
    staticClass: "navbar is-fixed-top",
    attrs: {
      "aria-label": "main navigation",
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('strong', {
    staticClass: "has-text-primary"
  }, [_vm._v("OCM 2026")])]), _c('a', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.navigationDrawerOpen
    },
    attrs: {
      "aria-expanded": "false",
      "aria-label": "menu",
      "data-target": "navbarBasicExample",
      "role": "button"
    },
    on: {
      "click": function ($event) {
        _vm.navigationDrawerOpen = !_vm.navigationDrawerOpen;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.navigationDrawerOpen
    },
    attrs: {
      "id": "navbarBasicExample"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_vm.isAdviserSignedIn ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("Início")]) : _vm._e(), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/regimento"
    }
  }, [_vm._v("Regimento")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/provas"
    }
  }, [_vm._v("Provas")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/published-students"
    }
  }, [_vm._v("Lista de inscritos")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/premiacao"
    }
  }, [_vm._v("Premiação")]), _vm.isAdviserSignedIn && _vm.isAdviserActive ? _c('b-navbar-dropdown', {
    attrs: {
      "label": "Inscrição"
    }
  }, [this.$store.getters.canEnroll ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/enroll/spreadsheet"
    }
  }, [_vm._v(" Enviar planilha ")]) : _vm._e(), this.$store.getters.canSubmitPayment ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/payment"
    }
  }, [_vm._v(" Enviar comprovantes de pagamento ")]) : _vm._e(), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/list"
    }
  }, [_vm._v("Seus Alunos inscritos")])], 1) : _vm._e()], 1), !_vm.isAdviserSignedIn ? _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Cadastrar")]), _c('router-link', {
    staticClass: "button is-light",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Entrar")])], 1)])]) : _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_vm.isSchoolInfoLoaded ? _c('p', {
    staticClass: "has-text-right"
  }, [_c('strong', [_vm._v(_vm._s(this.$store.state.adviser.inep))]), _vm._v(" - " + _vm._s(this.$store.state.school.name)), _c('br'), _vm._v(" " + _vm._s(this.$store.state.adviser.name) + " ")]) : _c('p', [_vm._v(" Carregando... ")])]), _c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button is-outlined is-danger",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v("Sair")])])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };